import {SafetyCertificateOutlined} from '@ant-design/icons';
import React, {useRef, FC} from 'react';

import {IModalOpenerComponentRef} from 'components/modal-opener-component';
import {ActionButton} from 'components/table/action/action-button';
import {ITableActionProps} from 'components/table/action/table-action-types';
import {SignWithCryptoProModal} from 'features/sign-with-crypto-pro';
import {resetLoadedData, selectEntityData} from 'modules/data';
import {setData} from 'modules/data/data-actions';
import {ITableEntityData} from 'modules/data/data-types';
import {EEntityType} from 'shared/constants/entities';
import {useAppDispatch, useAppSelector} from 'store/config/hooks';
import {EDocumentsSigningMethod, selectDocumentsSigningMethod} from 'store/slices/documents-uploading-slice';

interface IOpenCryptoProSigningModalProps extends ITableActionProps {}

export const OpenCryptoProSigningModal: FC<IOpenCryptoProSigningModalProps> = ({
    meta,
    wrapper,
    entityName,
    ...props
}: IOpenCryptoProSigningModalProps) => {
    const dispatch = useAppDispatch();

    const {
        selectedRowKeys = [],
        selectedRows = [],
    } = useAppSelector(selectEntityData(entityName, EEntityType.TABLE)) as ITableEntityData ?? {};

    const documentsSigningMethod = useAppSelector(selectDocumentsSigningMethod);

    const signingModalRef = useRef<IModalOpenerComponentRef>(null);

    const onClick = async () => {
        signingModalRef.current?.showModal();
    };

    if (documentsSigningMethod !== EDocumentsSigningMethod.CRYPTO_PRO_PLUGIN) return null;
    const ComponentWrapper = wrapper || ActionButton;

    const attachmentIds: string[] = selectedRows.reduce<string[]>((acc, item) => {
        const {fileList} = item;
        const id: string | null = Array.isArray(fileList) && fileList.length > 0 && 'attachmentId' in fileList[0]
            ? fileList[0].attachmentId.toString()
            : null;

        if (id !== null) acc.push(id);
        return acc;
    }, []);

    return (
        <>
            <ComponentWrapper
                {...props}
                onClick={onClick}
                actionIcon={meta.actionIcon}
                disabled={!selectedRowKeys?.length}
            >
                <SafetyCertificateOutlined />
                {meta.actionTitle}
            </ComponentWrapper>

            <SignWithCryptoProModal
                ref={signingModalRef}
                className="d-none"
                entityName={entityName}
                documentIds={selectedRowKeys as string[]}
                attachmentIds={attachmentIds}
                onStart={() => {
                    dispatch(setData({
                        entityName,
                        entityType: EEntityType.TABLE,
                        data: {
                            selectedRowKeys: [],
                            selectedRows: [],
                        },
                    }));
                }}
                onFinish={() => {
                    dispatch(resetLoadedData(entityName, EEntityType.TABLE));
                }}
            />
        </>

    );
};
